import { OPTED_OUT } from "./constants";

export function loyaltyTierRuleFactory(consentStatus, customerTierId) {
  return async function loyaltyTierRule(node) {
    const { loyaltyTiersIncluded, loyaltyTiersExcluded } = node;

    if (!loyaltyTiersIncluded.length && !loyaltyTiersExcluded.length) {
      return true;
    }

    if (consentStatus === OPTED_OUT) {
      return false;
    }

    if (loyaltyTiersExcluded.includes(customerTierId)) {
      return false;
    }

    return (
      !loyaltyTiersIncluded.length ||
      loyaltyTiersIncluded.includes(customerTierId)
    );
  };
}
